import React from "react";
import "react-awesome-slider/dist/styles.css";
import "react-awesome-slider/dist/custom-animations/open-animation.css";
import Services from "./Services";
import HomeSliderReactAnimated from "../components/Sliders/HomeSliderReactAnimated";
import Contact from "./Contact";
import About from "./About";
import HowItWorks from "./HowItWorks";
import Portfolio from "./Portfolio";

// No modal state here — all handled by ContactModalContext

function Home() {
  return (
    <div>
      <section id="home">
        <HomeSliderReactAnimated />
      </section>
      <div className="mt-5">
        <About />
      </div>
      <div className="h-1 w-full bg-main"></div>

      <div>
        <Services />
      </div>
      <div className="mb-5">
        <Portfolio />
        <HowItWorks />
      </div>
      <div className="mt-10">
        <Contact />
      </div>
    </div>
  );
}

export default Home;